import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  subHeaderBeforeSubTitleStyle: {
    fontSize: 18.7,
    lineHeight: 25,
    color: Colors.dark_grey,
    fontFamily: Fonts.VFFont,
  },
  subHeaderTitleStyle: {
    fontSize: 25,
    lineHeight: 26,
    color: Colors.dark_grey,
    marginTop: 12,
  },
  subHeaderFullContainerStyle: {
    marginLeft: 6,
  },
  subHeaderDescriptionStyle: {
    lineHeight: 22.9,
    fontSize: 16.6,
    color: Colors.light_grey,
  },
  pageBannerTitleStyle: {
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  pageBannerDescriptionStyle: {
    marginLeft: 7,
  },
  iconAndTitleContainerStyle: {
    alignItems: 'flex-start',
  },
});
